<template>
	<f7-app :params="f7params">
		<f7-appbar v-if="useAppBar&&custUseAppBar">
			<div class="width-100 text-align-center">{{title}}</div>
		</f7-appbar>
		<!-- <f7-view :iosSwipeBack="false" :animate="false" :main="true" url="/" :pushState="true"></f7-view> -->
		<f7-view :class="{'showP':store_ShowPeriod}" :iosSwipeBack="false" :animate="false" :main="true" url="/" :pushState="true" :stackPages="true" :allowDuplicateUrls="false" :preloadPreviousPage="true" :restoreScrollTopOnBack="true"></f7-view>
	</f7-app>
</template>

<script>
	import filters from "@/scripts/filters.js";
	import axiosEx from "@/scripts/axiosEx.js";

	import routes from "./routes.js";

	export default {
		data() {
			var self = this;
			return {
				isH5Ready: 0,
				delayCall: undefined,
				useAppBar: false,
				custUseAppBar: false,
				f7params: {
					routes,
					name: "老板看账",
					id: "boss",
					theme: "ios",
					on: {
						init() {
							self.$f7ready(() => {
								//判断是否微信内置浏览器
								if (localStorage.getItem('wxCode') || navigator.userAgent.toLowerCase().indexOf('micromessenger') < 0) {
									//这里只是为了本地调试
									self.initBindWx(self.initApp)
								} else {
									self.$lmsvr.bind.SearchOpenId(location.search).then(r => {
										if (r.Data.isOk) {
											localStorage.setItem('wxCode', r.Data.openid);
											//self.$f7.dialog.alert("wxCode", r.Data.openid)
											self.initBindWx(self.initApp)
										} else {
                      						self.$f7.dialog.alert("m1", r.Data.errmsg);
											callback && callback();
										}
									})
								}
								self.$watch('isH5Ready', newVal => {
									if (newVal != 200 || !self.delayCall) return;

									if (!self.isLogin()) {
										var router = self.$f7.views.main.router;
										router.navigate("/", {
											browserHistory: false,
										})
										return;
									}
									self.delayCall();
									self.delayCall = undefined;
									console.log("delayCall")
								})
							});
						},
						initPageData(callback) {
							if (self.isH5Ready == 200) {
								if (!self.isLogin()) {
									var router = self.$f7.views.main.router;
									router.navigate("/", {
										browserHistory: false,
									})
									return;
								}
								console.log("call111")
								callback && callback();
							} else {
								self.delayCall = callback;
							}
						},
						initEnv(callback) {
							self.initDZ(callback);
						},
						initAs(callback) {
							self.initPeriodSection(callback)
						},
						initUser(callback) {
							self.initBindWx()
						},
						refreshError(callback) {
							self.initBindWx(callback)
						},
						
					},
					dialog: {
						buttonOk: "确定",
						buttonCancel: "取消",
					},
					view: {
						routesBeforeEnter(_to, _from, _resolve, _reject) {
							if (self.isLogin() || _to.route.meta && _to.route.meta.permission == false) {
								_resolve();
							} else {
								_reject();
								var router = self.$f7.views.main.router;
								router.navigate('/login/')
								console.log(_to, _from);

							}
						},
						routesBeforeLeave(_to, _from, _resolve, _reject) {
							while (true) {
								let pp_sheet = self.$f7.sheet.close();
								if (!pp_sheet) break;
								// else pp.targetEl.parent.remove(pp.targetEl);
							}
							while (true) {
								let pp_popover = self.$f7.popover.close();
								if (!pp_popover) break;
							}
							_resolve();
						},
					},
					navbar: {
						animate: false,
					},
				},
			}
		},
		methods: {
			//判断进入哪个账套
			judge(){
				let list = [];
				let listPro = [];
				let listConcat = [];
				let listErp = [];
				let listErpFree = [];
				let selectItem = {};
				return new Promise(resolve=>{
					//先判断免费版权限
					this.$lmsvr.jmApi.AcList().then(r => {
						list= r.value;
						listConcat = [...listConcat,...list]
						if(r.value.length>0){
						}
						//再判断专业版权限
						this.$lmsvr.jmProApi.AcList().then(r=>{
							listPro= r.value;
							listConcat = [...listConcat,...listPro];
							if(r.value.length>0){
							}
							this.$lmsvr.erpFreeApi.AcList().then(r=>{
								listErpFree = r.value;
								listConcat = [...listConcat,...listErpFree];
								if(r.value.length>0){
								}
								this.$lmsvr.erpApi.AcList().then(r=>{
								listErp = r.value;
								listConcat = [...listConcat,...listErp];
								if(r.value.length>0){
								}
								console.log('是否拿到了上次的账套Id',localStorage.getItem('AsId'))
								console.log('权限1',this.store_permission)
								//现在的逻辑，不是把AsId存到当前用户登录的手机号下面，这种逻辑当一个用户有多个手机号的时候，会有问题，后续会改。
								//非首次登录用户，直接进入上次退出的账套(得保证此账套现在还有权限即还能在我的账套列表中找到)
								if(localStorage.getItem('AsId')){
									//上次的账套还存在
									if((listConcat.findIndex(v => v.AsId == localStorage.getItem('AsId')))>-1){
										selectItem = listConcat.find(v => v.AsId == localStorage.getItem('AsId'));
									}else{
										console.log('上次进入的账套没有权限');
										if(localStorage.getItem('authType')){
											const type = localStorage.getItem('authType');
											if(type == 'jmpro'){
												//上次进入的版本还有其它账套的话，就进其它账套。否则就进业财免费版、其次业财专业版、最后免费版
												if(listPro.length){
													selectItem = listPro[0];
												}else if(listErpFree.length){
													selectItem = listErpFree[0];
												}else if(listErp.length){
													selectItem = listErp[0];
												}else if(list){
													selectItem = list[0];
												}
											}else if(type == 'jm'){
												if(list.length){
													selectItem = list[0];
												}else if(listPro.length){
													selectItem = listPro[0];
												}else if(listErpFree.length){
													selectItem = listErpFree[0];
												}else if(listErp.length){
													selectItem = listErp[0];
												}
											}else if(type == 'erp'){
												if(listErp.length){
													selectItem = listErp[0];
												}else if(listErpFree.length){
													selectItem = listErpFree[0];
												}else if(listPro.length){
													selectItem = listPro[0];
												}else if(list){
													selectItem = list[0];
												}
											}else if(type == 'erpfree'){
												if(listErpFree.length){
													selectItem = listErpFree[0];
												}else if(listErp.length){
													selectItem = listErp[0];
												}else if(listPro.length){
													selectItem = listPro[0];
												}else if(list){
													selectItem = list[0];
												}
											}
										}
									}
									// this.$f7.dialog.alert('拿到了上次的账套id')
								}else{
									console.log('2222222222222',this.store_permission);
									// this.$f7.dialog.alert('没拿到上次的账套id')
									//首次登录用户，进入账套优先级：专业版>业财>免费版
									if(this.store_permission == 'jm'){
										selectItem = list[0];
									}else if(this.store_permission == 'jmpro'){
										selectItem = listPro[0];
									}else if(this.store_permission == 'erp'){
										selectItem = listErp[0];
									}else if(this.store_permission == 'erpfree'){
										selectItem = listErpFree[0];
									}
									// this.$f7.dialog.alert('拥有的权限',this.store_permission)
								}
								console.log('selectItem',selectItem)



								//有任一权限时，重置账套列表+重新设置当前版本（专业版/免费版/业财），因为有可能用户进入的是上一次的退出的账套
								// this.$f7.dialog.alert('selectItem',selectItem)
								if(list.includes(selectItem)){
									this.$setAsLists(list)
									this.$setPermission('jm')
								}else if(listPro.includes(selectItem)){
									this.$setAsLists(listPro)
									this.$setPermission('jmpro')
								}else if(listErpFree.includes(selectItem)){
									this.$setAsLists(listErpFree)
									this.$setPermission('erpfree')
								}else if(listErp.includes(selectItem)){
									this.$setAsLists(listErp)
									this.$setPermission('erp')
								}

								if(!this.store_permission){
									return this.$f7.dialog.alert("", "暂无账套数据")
								}

								console.log('权限2',this.store_permission)
								console.log('列表',this.store_AsLists)

								this.$setAsId(selectItem.AsId);
								localStorage.setItem('AsId', selectItem.AsId);
								localStorage.setItem('authType',this.store_permission)
								this.$setAsName(selectItem.AsName)
								this.$setAsItem(selectItem)
								this.initPeriodSection();
								resolve()
							})
							})
						})	
					})
				})
			},
			initJZ(callback) {
				var self = this;
				var router = self.$f7.views.main.router;
				router.clearHistory();
				self.$lmsvr.jmApi.AcList().then(r => {
					if (r.value.length != 0) {
						var selectItem = r.value.find(v => v.AsId == localStorage.getItem('AsId')) || r.value[0];
						self.$setAsId(selectItem.AsId);
						localStorage.setItem('AsId', selectItem.AsId);
						self.$setAsName(selectItem.AsName)
						self.$setAsItem(selectItem)
						self.$setAsLists(r.value)
						self.initPeriodSection();
					} else {
						this.$f7.dialog.alert("", "暂无账套数据")
					}
					callback && callback();
				}).catch(err => {
					// this.$f7.dialog.alert("测试弹框-不用管222", err)
					router.navigate("/errorPage/")
				})
			},
			initDZ(callback) {
				var self = this;
				var router = self.$f7.views.main.router;
				router.clearHistory();
				self.$lmsvr.dzApi.GetCompanyList({
					"phone": self.store_UserInfo.phone,
				}).then(r => {
					if (r.Data.length != 0) {
						var selectItem = r.Data.find(v => v.CustId == localStorage.getItem('CustId')) || r.Data[0];
						// AccAsType // 1010-免费 、1020-专业版
						localStorage.setItem('dzVersion',selectItem.AccAsType)
						self.$setAsId(selectItem.AccAsId);
						self.$setCustId(selectItem.CustId)
						localStorage.setItem('AsId', selectItem.AccAsId)
						localStorage.setItem('CustId', selectItem.CustId)
						self.$setAsName(selectItem.CustName)
						self.$setAsItem(selectItem)
						self.$setAsLists(r.Data)
						self.initPeriodSection();
					} else {
						self.$setAsId("");
						localStorage.removeItem('AsId');
						self.$setAsName("")
						self.$setAsItem("")
						self.$setAsLists("")
						self.$setCustId("")
						this.$f7.dialog.alert("", "暂无账套数据")
					}
					callback && callback();
				}).catch(err => {
					router.navigate("/errorPage/")
				})
			},
			initPeriodSection(callback) {
				var self = this;
				this.$lmsvr.jmApi.PeriodSectionPicker().then(r => {
					if (r && r.length > 0) {
						self.$setPeriodSection(r);
					}
					self.$set(self, "isH5Ready", 200);
					callback && callback();
				}).catch(err => {
					self.$set(self, "isH5Ready", 500);
					// this.$f7.dialog.alert("测试弹框-不用管111", err)
					router.navigate("/errorPage/")
				})
			},
			initBindWx(callback) {
        // alert(5)
				var self = this;
				if (this.lm_env == 'jz') {
					self.userInfo();
					callback && callback();
					return;
				}
				var wxCode = localStorage.getItem('wxCode');
				if (!wxCode) {
					self.$f7.dialog.alert("", "请用微信重新打开");
					callback && callback();
					return;
				}
				self.$lmsvr.bind.HasBind(wxCode).then(r => {
					if (!r.Data.HasBind) {
						var router = self.$f7.views.main.router;
						localStorage.removeItem('login_user_' + self.lm_env)
						// router.navigate('/')
					} else {
						self.userInfo(r.Data.Phone);
						callback && callback();
					}
				})
			},
			async  verifyAuth(mobile, userSn) {
				if(this.lm_env == 'jz'){
					await this.judge();
					return;
				}
				var self = this;
				self.$lmsvr.customer.VerifyAuth("?phone=" + mobile + "&userSn=" + userSn).then((result => {
					if (result.Success) {
						self.$setAaId(result.Data.AaId);
						localStorage.setItem('AaId', result.Data.AaId);
						self.initDZ();
					}
				}))
			},
			userInfo(phone) {
				var self = this;
				self.$lmsvr.apimUser.User().then(d => {
					var router = self.$f7.views.main.router;
					console.log('d',d)
					if (!d) {
						if (this.isLogin()) {
						// this.$f7.dialog.alert("", "userInfo")
							router.navigate('/errorPage/')
						} else {
							localStorage.removeItem('login_user_' + self.lm_env)
							// router.navigate('/')
						}
						return;
					}
					self.$setUserInfo({
						userName: d.data.userName,
						nickName: d.data.nickName,
						userSn: d.data.userSn,
						phone: d.data.mobile,
					});
					if (this.lm_env == 'dz' && phone != d.data.mobile) {
						localStorage.removeItem('login_user_' + self.lm_env)
						// router.navigate('/')
						return;
					}
					self.verifyAuth(d.data.mobile, d.data.userSn);
				})
			},
			initApp() {
				var self = this;
				var router = self.$f7.views.main.router;
				router.clearHistory();
				filters.bindVue(self);
				self.$watch("useAppBar", newVal => {
					if (!newVal) return;
					self.setTitle(router.currentRoute)
				});
				self.setTitle(router.currentRoute);
				router.on("routeChanged", self.setTitle);
			},
			setTitle(to) {
				if (!to || !to.route) return;

				if (this.useAppBar) {
					if (to.route.hasOwnProperty("showAppBar")) {
						this.custUseAppBar = to.route.showAppBar;
					} else {
						this.custUseAppBar = true;
					}

					if (to && to.route && to.route.title) {
						this.title = to.route.title
					} else {
						this.title = "老板看账";
					}
				} else {
					this.custUseAppBar = false;
					if (to && to.route && to.route.title) {
						document.title = to.route.title
					} else {
						document.title = "老板看账";
					}
				}
			},
		},
		mounted() {
				if (this.isLogin() && Object.keys(this.store_UserInfo).length) {
					var self = this;

					self.$lmsvr.apimUser.User().then(t => {
						if (t) {
							self.$setUserInfo({
							userName: t.data.userName,
							nickName: t.data.nickName,
							userSn: t.data.userSn,
							phone: t.data.mobile
						});
						self.verifyAuth(t.data.mobile, t.data.userSn);
						} else if (this.isLogin()) {
							router.navigate("/errorPage/");
						} else {
							localStorage.removeItem("login_user_" + self.lm_env);
						}
					});
				}
		},
	}
</script>
<style scoped="scoped" lang="less">
	.showP {
		height: 100vh;
		overflow: hidden;
		position: fixed;
		top: 0;
		width: 100%;
	}
</style>
